var _line, _line2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadIconBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 85,
    viewBox: "0 0 78 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 48.21,
    x2: 40,
    y2: 71.21,
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 14.21,
    x2: 40,
    y2: 35.21,
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0 4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 7.21002,
    r: 6,
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 42.21,
    r: 6,
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 59.21,
    r: 6,
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 77.21,
    r: 6,
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 25.21,
    r: 6,
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 59.21,
    r: 6,
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 59.21,
    r: 6,
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 25.21,
    r: 6,
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 34.2309,
    y1: 10.692,
    x2: 12.8589,
    y2: 23.4435,
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 65.4066,
    y1: 23.4429,
    x2: 44.0346,
    y2: 10.6914,
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 44.0343,
    y1: 73.8597,
    x2: 65.4063,
    y2: 61.1082,
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 12.8586,
    y1: 61.1089,
    x2: 34.2306,
    y2: 73.8603,
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 32.21,
    x2: 8,
    y2: 52.21,
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 32.3733,
    y1: 39.8642,
    x2: 12.7637,
    y2: 29.5925,
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 12.7631,
    y1: 54.9595,
    x2: 32.3727,
    y2: 44.6878,
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0 4"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 65.502,
    y1: 29.5922,
    x2: 45.8924,
    y2: 39.8639,
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 70,
    y1: 52.21,
    x2: 70,
    y2: 32.21,
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 64.574,
    y1: 56.7312,
    x2: 44.9644,
    y2: 46.4595,
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0 4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIconBlack);
export default __webpack_public_path__ + "static/media/uploadIconBlack.a9a62774093ac2f710bc9426bdf0ed9d.svg";
export { ForwardRef as ReactComponent };